import { render, staticRenderFns } from "./CSideBar.vue?vue&type=template&id=5dc9d257&scoped=true&"
import script from "./CSideBar.vue?vue&type=script&lang=js&"
export * from "./CSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CSideBar.vue?vue&type=style&index=0&id=5dc9d257&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9d257",
  null
  
)

export default component.exports